import React from 'react'
import AdminYoutubeTasks from '../../Component/adminComp/AdminYoutubeTasks'

const AdminYoutube = () => {
  return (

<>
<AdminYoutubeTasks/>
{/* <Spinner/> */}

</>
  )
}

export default AdminYoutube